/**
 * Determines if the current location is consumer matches URL
 *
 * @param {Object} location the current location
 * @returns {boolean}
 */
export const isConsumerUrl = location => {
  return (location?.pathname ?? '').indexOf('/consumer/matches') !== -1;
};

/**
 * Determines if the current location is hierarchy items URL
 *
 * @param {Object} location the current location
 * @returns {boolean}
 */
export const isHierarchyItemUrl = location => {
  return (
    (location?.pathname ?? '').indexOf('/shutterbug/hierarchy-items') !== -1
  );
};

/**
 * Determines if the current location is for all photos matches URL
 *
 * @param {Object} location the current location
 * @param {String} albumMembershipGroupId the album membership group id
 * @param {String} forConsumers whether to fetch for consumers or for hierarchy items
 * @returns {boolean}
 */
export const isAllPhotosUrl = (
  location,
  albumMembershipGroupId,
  forConsumers = true,
) => {
  if (forConsumers) {
    return (
      location?.pathname === `/consumer/matches/${albumMembershipGroupId}/all`
    );
  }
  return location?.pathname === `/hierarchy-items/${albumMembershipGroupId}`;
};

/**
 * Determines if the current location is any of the albumMembershipGroup urls
 *
 * @param {Object} location the current location
 * @returns {boolean}
 */
export const isAlbumMembershipGroupUrl = location => {
  return isConsumerUrl(location) || isHierarchyItemUrl(location);
};
